import { Skeleton } from '@mint-lib/tw-components';

const ApprovalFlowTabSkeleton = () => {
  return (
    <div aria-label="Approval flow tab is loading">
      <Skeleton className="h-4 w-30" />
      <Skeleton className="mt-1 h-10 w-full" />
      <Skeleton className="mt-4 h-4 w-35" />
      <Skeleton className="mt-3 h-20 w-full" />
    </div>
  );
};

export default ApprovalFlowTabSkeleton;
